import { subTopicAnchorPath } from "@shapeable/gesda-ui";
import { SubTopic } from "@shapeable/types";

export const withSubTopicAnchorPath = <T extends SubTopic>(subTopic: T): T => ({
  ...subTopic,
  path: subTopicAnchorPath(subTopic),
});
